import axios from 'axios';
import { substituirMensagens, limparMensagens } from 'esocial.web.react.lib/cjs/store/reducers/mensagens';
import { idContainerMensagensGerais } from 'esocial.web.react.lib/cjs/components/layout/Layout';
import { TipoMensagem } from 'esocial.web.react.lib/cjs/utils/enums';
import {
    msgRelatorioDownloadErro, msgRelatorioSolicitadoErro, msgRelatorioSolicitadoSucesso, msgRelatorioSolicitadoJaExiste,
    msgRelatorioValidacaoErro, msgRelatorioValidacaoLimiteExcedido, msgRelatorioValidacaoSucesso, msgGetRelatoriosErro
} from './Mensagens';
import { rolarVisualizacaoAteElemento } from 'esocial.web.react.lib/cjs/utils/geral';
import { abrirModalCarregamento, fecharModalCarregamento } from "esocial.web.react.lib/cjs/store/reducers/modais";

const fetchData = async (url, callback) => {
    try {
        const response = await axios.get(url);
        // Execute the callback with the response data
        callback(response.data);
    } catch (error) {
        console.error('Error fetching data:', error);
        callback(null, error)
    }
};

const converteParaFormatoDoSeletor = (data) => {
    const result = Object.entries(data).map(([key, value]) => ({
        value: Number(key),
        label: value
    }));
    return result;
}

const inicioUrl = process.env.REACT_APP_FRONTEND_API_BASEURL;

export async function salvarNovaSolicitacaoRelatorio(novaSolicitacaoRelatorio, relatoriosSolicitados, setRelatoriosSolicitados, dispatch, post, navigate) {
    
    const processamentoResposta = (conteudoResposta) => {
        if (conteudoResposta.mensagens[0] == "Sucesso") {
            dispatch(substituirMensagens([{
                tipo: TipoMensagem.Sucesso,
                texto: msgRelatorioSolicitadoSucesso,
                idContainerMensagem: idContainerMensagensGerais,
                resistente: true
            }]));
            let novosRelatorios = [conteudoResposta.resultado, ...relatoriosSolicitados];
            setRelatoriosSolicitados(novosRelatorios);
            navigate('/gerenciamento');
        } else {
            if (typeof conteudoResposta.resultado !== 'string') {
                dispatch(substituirMensagens([{
                    tipo: TipoMensagem.Informacao,
                    texto: msgRelatorioSolicitadoJaExiste,
                    idContainerMensagem: idContainerMensagensGerais,
                    resistente: true
                }]));
                setRelatoriosSolicitados([conteudoResposta.resultado]);
                navigate('/gerenciamento');
            }
            else {
                dispatch(substituirMensagens([{
                    tipo: TipoMensagem.Erro,
                    texto: msgRelatorioSolicitadoErro + conteudoResposta.mensagens[0],
                    idContainerMensagem: idContainerMensagensGerais,
                    resistente: false
                }]));
            }
        }
        rolarVisualizacaoAteElemento(idContainerMensagensGerais);
    };
    const url = `${inicioUrl}relatorios`;
    await post(url, novaSolicitacaoRelatorio, processamentoResposta, undefined, { suprimirSobreposicaoMensagens: false });
}

export async function getRelatorios(tipoInscricaoEmpregador, numeroInscricaoEmpregador, tipoInscricaoSolicitante, numeroInscricaoSolicitante, setRelatoriosSolicitados, dispatch, get) {
    const processamentoResposta = (conteudoResposta) => {
        if (conteudoResposta.mensagens[0] == "Sucesso") {
            setRelatoriosSolicitados(conteudoResposta.resultado);
        } else {
            dispatch(substituirMensagens([{
                tipo: TipoMensagem.Erro,
                texto: msgGetRelatoriosErro + conteudoResposta.mensagens[0],
                idContainerMensagem: idContainerMensagensGerais,
                resistente: false
            }]));
        }
    };

    const paramNumeroInscricaoEmpregador = numeroInscricaoEmpregador.replace(/[^a-zA-Z0-9]/g, '');
    const paramNumeroInscricaoSolicitante = numeroInscricaoSolicitante.replace(/[^a-zA-Z0-9]/g, '');

    const url = new URL(`${inicioUrl}relatorios`);
    const searchParams = url.searchParams;
    searchParams.append('numeroInscricaoEmpregador', paramNumeroInscricaoEmpregador);
    searchParams.append('numeroInscricaoSolicitante', paramNumeroInscricaoSolicitante);
    searchParams.append('tipoInscricaoEmpregador', tipoInscricaoEmpregador);
    searchParams.append('tipoInscricaoSolicitante', tipoInscricaoSolicitante);

    await get(`${url}`, processamentoResposta);
}

const converteParaFormatoDoSeletorCbo = (data) => {
    let result = Object.entries(data).map(([key, value]) => ({
        value: Number(key),
        label: key + ' - ' + value
    }));
    result = [...result, { value: 0, label: '' }];
    return result;
}

const converteParaFormatoDoSeletorCategorias = (data) => {
    const dataArray = Object.entries(data).map(([key, value]) => ({
        key: parseInt(key), // Convert key to a number if necessary
        value
    }));

    const grouped = dataArray.reduce((acc, { key, value }) => {
        const firstDigit = String(key)[0];
        if (!acc[firstDigit]) {
            acc[firstDigit] = [];
        }
        acc[firstDigit].push({ key, value });
        return acc;
    }, {});

    const result = Object.entries(grouped).map(([group, items]) => ({
        label: `Grupo de Categoria ${group}`,  // Change this to any custom label logic you want
        isGroup: true,
        children: items.map(({ key, value }) => ({
            value: Number(key),
            label: key + ' - ' + value
        })),
    }));

    return result;
}

const fileExtension = (mimeType) => {
    switch (mimeType) {
        case 'application/pdf':
            return ".pdf";
        case 'text/csv':
            return ".csv";
        case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
            return ".xlsx";
        default:
            return null;
    }
};

export const downloadFile = async (relatorio, dispatch, get, mimeType) => {
    const processamentoResposta = (conteudoResposta) => {
        const extension = fileExtension(mimeType);
        var filename = relatorio.arquivo?.nome != null
            ? relatorio.arquivo.nome.replace(".csv", extension)
            : null;

        const { downloadUrl, fileName: apiFileName } = conteudoResposta.resultado;
        filename = filename ?? apiFileName ?? `relatorio-${relatorio.id}${extension}`;

        if (conteudoResposta.resultado == null) {
            const mensagens = conteudoResposta.mensagens;
            processamentoErro(filename, mensagens instanceof Array ? mensagens[0] : null);
            return;
        }

        if (!downloadUrl) {
            processamentoErro(filename, 'URL de download não encontrada');
            return;
        }

        fetch(downloadUrl)
            .then(response => {
                if (!response.ok) throw new Error('Falha ao baixar o arquivo');
                return response.blob();
            })
            .then(blob => {
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.setAttribute('download', filename);
                link.style.display = 'none';
                document.body.appendChild(link);
                link.click();
                window.URL.revokeObjectURL(link.href);
                document.body.removeChild(link);
            })
            .catch(error => {
                processamentoErro(filename, error.message || error);
            });

        dispatch(limparMensagens());
    }

    const processamentoErro = (arquivo, mensagem = null) => {
        console.error(`Erro ao baixar o arquivo "${arquivo}"`);
        dispatch(substituirMensagens([{
            tipo: TipoMensagem.Erro,
            texto: mensagem ?? msgRelatorioDownloadErro,
            idContainerMensagem: idContainerMensagensGerais,
            resistente: false
        }]));
        rolarVisualizacaoAteElemento(idContainerMensagensGerais);
    };

    try {
        const urlGet = `${inicioUrl}arquivo?id=${relatorio.id}`;
        await get(urlGet, processamentoResposta, { headers: { 'Accept': mimeType } });
    } catch (error) {
        processamentoErro(error);
    }
};

// ------------------ ENDPOINTS PÚBLICOS ----------------------
export async function getConstantes(setOpcoesTipoRelatorio, setDescricaoSituacao, setOpcoesTipoEstabelecimento, setOpcoesCBO, setOpcoesCategorias, dispatch) {
    const processamentoResposta = (conteudoResposta, erro) => {
        dispatch(fecharModalCarregamento());
        if (!erro) {
            setOpcoesTipoRelatorio(converteParaFormatoDoSeletor(conteudoResposta.descricaoTiposRelatorio));
            setDescricaoSituacao(conteudoResposta.descricaoSituacao);

            //Tabelas
            const tiposEstabelecimentosValidos = Object.fromEntries(
                Object.entries(conteudoResposta.tiposEstabelecimento).filter(([_, value]) => !["CEI", "CGC", "CPF"].includes(value))
            );
            setOpcoesTipoEstabelecimento(converteParaFormatoDoSeletor(tiposEstabelecimentosValidos));
            setOpcoesCBO(converteParaFormatoDoSeletorCbo(conteudoResposta.cbos));
            setOpcoesCategorias(converteParaFormatoDoSeletorCategorias(conteudoResposta.categorias));
        } else {
            // handle error
        }
    };
    const url = `${inicioUrl}constantes`;
    dispatch(abrirModalCarregamento());
    await fetchData(url, processamentoResposta);
}

export async function validarRelatorio(chave, numeroInscricao, tipoInscricao, dataSolicitacao, setRelatorioVal, dispatch) {
    const processamentoResposta = (conteudoResposta, erro) => {
        dispatch(fecharModalCarregamento());
        if (!erro) {
            dispatch(substituirMensagens([{
                tipo: TipoMensagem.Sucesso,
                texto: msgRelatorioValidacaoSucesso,
                idContainerMensagem: idContainerMensagensGerais,
                resistente: false
            }]));
            setRelatorioVal([conteudoResposta]);
        } else {
            const msgs = {
                "404": msgRelatorioValidacaoErro,
                "429": msgRelatorioValidacaoLimiteExcedido,
            };
            dispatch(substituirMensagens([{
                tipo: TipoMensagem.Erro,
                texto: msgs[`${erro.response.status}`],
                idContainerMensagem: idContainerMensagensGerais,
                resistente: false,
            }]));
        }
        rolarVisualizacaoAteElemento(idContainerMensagensGerais);
    };
    setRelatorioVal();
    let paramNumeroInscricao = numeroInscricao.replace(/[^a-zA-Z0-9]/g, '')
    if (tipoInscricao == 1) {
        paramNumeroInscricao = paramNumeroInscricao.substring(0, 8); //pega só a raiz do CNPJ
    }
    const paramDataSolicitacao = dataSolicitacao;
    const url = `${inicioUrl}validacao?chave=${chave}&numeroInscricao=${paramNumeroInscricao}&tipoInscricao=${tipoInscricao}&dataSolicitacao=${paramDataSolicitacao}`;
    dispatch(abrirModalCarregamento());
    await fetchData(url, processamentoResposta);
}
